<template>
  <table class="mds-data-table change-status__table">
    <thead class="mds-data-table__header">
      <tr class="mds-data-table__row">
        <th class="mds-data-table__header-cell" width="44" scope="col">
          <div class="mds-data-table__header-cell-inner mds-data-table__header-cell--left"></div>
        </th>
        <th class="mds-data-table__header-cell" width="20%" scope="col">
          <div class="mds-data-table__header-cell-inner mds-data-table__header-cell--left">
            Current Status
          </div>
        </th>
        <th class="mds-data-table__header-cell" width="20%" scope="col">
          <div class="mds-data-table__header-cell-inner mds-data-table__header-cell--left">
            Change Status
          </div>
        </th>
        <th class="mds-data-table__header-cell" scope="col">
          <div class="mds-data-table__header-cell-inner mds-data-table__header-cell--left"></div>
        </th>
      </tr>
    </thead>
    <tbody class="mds-data-table__body">
      <tr class="change-status__shareclass mds-data-table__row">
        <td class="mds-data-table__cell">
          <div v-if="isPending" class="pending-icon mds-icon">
            <svg class="mds-icon" aria-hidden="true">
              <use
                xmlns:xlink="http://www.w3.org/1999/xlink"
                xlink:href="static/mds/icons/mds.svg#clock-back"
              ></use>
            </svg>
          </div>
        </td>
        <td class="mds-data-table__cell mds-data-table__cell--left">
          <status-icons :status="statusArray" />
          {{ statusText }}
        </td>
        <td class="mds-data-table__cell mds-data-table__cell--left">
          <status-icons v-if="newStatus" :status="[{ name: newStatusIcon }]" />
          <div v-else class="status-icons"></div>
          <div class="mds-form__select">
            <select
              class="mds-form__select-input change-status__select--funds-group"
              id="change-status__select--funds-group"
              :value="newStatus"
              @change="onSelect"
            >
              <option
                v-for="option in options"
                class="mds-form__select-option"
                :value="option.value"
                :disabled="option.config.disabled"
                :key="option.value"
              >
                {{ option.label }}
              </option>
            </select>
            <div class="mds-form__select-visual-wrap"></div>
            <span class="mds-form__select-open-indicator">
              <svg class="mds-icon mds-form__select-open-icon" aria-hidden="true">
                <use xlink:href="static/mds/icons/mds.svg#caret-down--s"></use>
              </svg>
            </span>
          </div>
        </td>
        <td class="mds-data-table__cell"></td>
      </tr>
    </tbody>
  </table>
</template>
<script>
import StatusIcons from '@/components/atoms/StatusIcons';

export default {
  name: 'change-status-shareclass',
  components: {
    StatusIcons,
  },
  props: {
    statusArray: {
      type: Array,
      required: true,
    },
    statusText: {
      type: String,
      default: '',
    },
    options: {
      type: Array,
      default() {
        return [];
      },
    },
    newStatus: {
      type: Number,
      default: 0,
    },
    newStatusIcon: {
      type: String,
      default: '',
    },
    isPending: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  methods: {
    onSelect(event) {
      this.$emit('onSelect', parseInt(event.target.value, 10));
    },
  },
};
</script>
<style lang="scss">
.change-status__shareclass {
  & div[class^="status-array"] {
    display: inline;
  }
  & .status-icons {
    margin-right: $mds-space-half-x;
  }
  & .mds-form__select {
    margin-top: -$mds-space-1-x;
  }
}
</style>
